import React from 'react';
import type { FieldConfigurationComponentProps } from '../../../../types.tsx';
import type { AssociatedField } from '../../../../types/layout-items.tsx';
import { FieldOptions } from '../field-options/index.tsx';
import { isDefaultOption, refineDefaultValue } from '../field-options/view.tsx';
import { DefaultValueControlLeft, DefaultValueControlRight } from './default-value/view.tsx';
import messages from './messages.tsx';

export const onFieldUpdate =
	(onUpdate: FieldConfigurationComponentProps['onUpdate']) =>
	(field: AssociatedField): void => {
		const { defaultValue, options } = field;

		if (options == null) {
			onUpdate(field);
			return;
		}
		const refined = refineDefaultValue(defaultValue);
		if (refined.length === 0) {
			onUpdate(field);
			return;
		}
		const updatedDefaultOptions = options.filter(isDefaultOption(refined));
		onUpdate({
			...field,
			defaultValue: updatedDefaultOptions.length ? updatedDefaultOptions : undefined,
		});
	};

/**
 * Checkbox is a multi-select: comes with options, allows multiple options as default.
 */
export const CheckboxFieldConfiguration = (props: FieldConfigurationComponentProps) => (
	<FieldOptions
		{...props}
		label={messages.optionsLabel}
		onUpdate={onFieldUpdate(props.onUpdate)}
		DefaultValueControlLeft={DefaultValueControlLeft}
		DefaultValueControlRight={DefaultValueControlRight}
	/>
);
